import { hasScope, hasScopeSuffixes } from '../../util/AuthUtils';
/**
 * Renders the child elements if this user has the proper Hyrule scopes, otherwise null.
 * @param scopes - An array of Hyrule scopes
 * @param suffixes - An array of Hyrule scope suffixes to check (e.g. '_scopes_admin')
 * @param children - Children JSX element(s)
 */
const HasScopes = _ref => {
  let {
    scopes,
    suffixes,
    children
  } = _ref;
  if (scopes && hasScope(scopes) || suffixes && hasScopeSuffixes(suffixes)) {
    return children;
  }
  return null;
};
export default HasScopes;